import React, { forwardRef } from 'react';
import { Loader } from '../loading';
import * as S from './button.styles';
export var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["PRIMARY"] = "primary";
    ButtonVariant["SECONDARY"] = "secondary";
    ButtonVariant["DARK"] = "dark";
    ButtonVariant["LIGHT"] = "light";
    ButtonVariant["LINK"] = "link";
    ButtonVariant["SELECTED"] = "selected";
})(ButtonVariant || (ButtonVariant = {}));
/**
 * Exported using forwardRef because frameworks like NextJS require refs to be passed along.
 */
const Button = forwardRef((props, ref) => {
    const { type = 'button', isLoading, isDisabled, children, testId } = props;
    return (
    /**
     * Unfortunately because of a bug in styled-components 4.x it is not possible to properly type
     * the ref prop. The only solution now is to add 'as any'.
     * @see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/30451
     */
    React.createElement(S.Button, Object.assign({}, props, { type: type, ref: ref, "data-testid": testId, disabled: isDisabled || isLoading }), isLoading ? React.createElement(Loader, { width: "35px", height: "35px", inverted: true }) : children));
});
Button.displayName = 'Button';
export { Button };
//# sourceMappingURL=button.js.map